/**
 * Shared password complexity policy — Global Design System directive
 * (2026-09-01): minimum 8 characters, at least 1 uppercase letter,
 * 1 number, and 1 special character. Used by Register.jsx and
 * BrokerSignup.jsx so the requirement checklist UI stays identical.
 */
export function passwordChecks(pw) {
    return {
        len8:    pw.length >= 8,
        upper:   /[A-Z]/.test(pw),
        digit:   /\d/.test(pw),
        special: /[^A-Za-z0-9]/.test(pw),
    };
}

export function passwordMeetsPolicy(pw) {
    const c = passwordChecks(pw);
    return c.len8 && c.upper && c.digit && c.special;
}
